export default __webpack_public_path__ + "static/media/profile.0164a8b5.png";